<div class="export-error" *ngIf="errorMessage">{{ errorMessage }}</div>

<div class="export-brand" *ngIf="overviewData">
	<span class="export-brand__label">powered by</span>
	<img
		class="export-brand__logo"
		src="assets/logo/lolly-logo.svg"
		alt="Lolly"
	/>
</div>

<!-- Disable all Angular animations for the print render: the section-card
	@collapse (:enter) animates the body from height:0 up to its natural height,
	and any intermediate/leftover state captured by headless-Chromium can clip a
	card body (seen as Campaign Ideas showing a single card). A static PDF has no
	use for entry animations, so switch them off and render final state directly. -->
<app-discovery-profile
	*ngIf="overviewData"
	[@.disabled]="true"
	[overviewData]="overviewData"
	[personalAnalysisData]="personalAnalysisData"
	[hideProfileMenu]="true"
	[socialMediaControl]="socialMediaControl"
></app-discovery-profile>
